import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import React, { useCallback, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchSelectorTopics } from 'actions/topics';
import isSearchMatch from 'utils/isSearchMatch';
import Modal from 'components/Modal';
import ErrorBoundary from 'components/ErrorBoundary';
import ItemPickerUI from 'components/ItemPicker/ItemPickerUI';
import useItemPickerView from 'components/ItemPicker/useItemPickerView';
import TopicSelectorBody from './TopicSelectorBody';
function TopicSelector(_ref) {
  var initialSelected = _ref.initialSelected,
    _ref$initialIndetermi = _ref.initialIndeterminate,
    initialIndeterminate = _ref$initialIndetermi === void 0 ? [] : _ref$initialIndetermi,
    onChangeSelectedTopics = _ref.onChangeSelectedTopics,
    onClose = _ref.onClose,
    isLoadingInitial = _ref.isLoadingInitial;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(initialSelected),
    _useState2 = _slicedToArray(_useState, 2),
    selectedItems = _useState2[0],
    setSelectedItems = _useState2[1];
  var _useState3 = useState(initialIndeterminate),
    _useState4 = _slicedToArray(_useState3, 2),
    indeterminateItems = _useState4[0],
    setIndeterminateItems = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    itemsToAdd = _useState6[0],
    setItemsToAdd = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    itemsToRemove = _useState8[0],
    setItemsToRemove = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    searchValue = _useState10[0],
    setSearchValue = _useState10[1];
  var indeterminateItemIds = indeterminateItems.map(function (topic) {
    return topic.id;
  });
  var title = t('actions_assign_topics');
  var _useItemPickerView = useItemPickerView({
      title: title,
      searchValue: searchValue,
      clearSearchValue: function clearSearchValue() {
        return setSearchValue('');
      }
    }),
    view = _useItemPickerView.view,
    changeView = _useItemPickerView.changeView;
  var _useFetchSelectorTopi = useFetchSelectorTopics(),
    topics = _useFetchSelectorTopi.items,
    isLoadingAllTopics = _useFetchSelectorTopi.isLoading;
  var isLoading = isLoadingInitial || isLoadingAllTopics;
  var selectedItemIds = useMemo(function () {
    return selectedItems.map(function (topic) {
      return topic.id;
    });
  }, [selectedItems]);
  var onChange = useCallback(function (changedItem, isItemSelected) {
    if (isItemSelected) {
      var _itemsToAdd = [changedItem];
      var topic = topics === null || topics === void 0 ? void 0 : topics.find(function (el) {
        return el.id === changedItem.id;
      });
      var parent = topic !== null && topic !== void 0 && topic.parent_id ? topics === null || topics === void 0 ? void 0 : topics.find(function (el) {
        return el.id === topic.parent_id;
      }) : null;
      var nonIndeterminateSelectedItemIds = selectedItems.filter(function (item) {
        return !item.isIndeterminate;
      }).map(function (item) {
        return item.id;
      });
      if (parent && !nonIndeterminateSelectedItemIds.includes(parent.id)) {
        _itemsToAdd.push(parent);
      }
      setSelectedItems(function (oldSelectedItems) {
        return [].concat(_toConsumableArray(oldSelectedItems), _itemsToAdd);
      });
      var itemIds = _itemsToAdd.map(function (topic) {
        return topic.id;
      });
      setIndeterminateItems(function (indeterminateItems) {
        return indeterminateItems.filter(function (item) {
          return !itemIds.includes(item.id);
        });
      });
      setItemsToAdd(function (oldItemsToAdd) {
        return _toConsumableArray(new Set([].concat(_toConsumableArray(oldItemsToAdd), _itemsToAdd)));
      });
    } else {
      var children = topics === null || topics === void 0 ? void 0 : topics.filter(function (el) {
        return el.parent_id === changedItem.id;
      });
      var _itemsToRemove = [changedItem].concat(_toConsumableArray(children));
      var itemIdsToRemove = _itemsToRemove.map(function (topic) {
        return topic.id;
      });
      setSelectedItems(function (selectedItems) {
        return selectedItems.filter(function (item) {
          return !itemIdsToRemove.includes(item.id);
        });
      });
      setIndeterminateItems(function (indeterminateItems) {
        return indeterminateItems.filter(function (item) {
          return !itemIdsToRemove.includes(item.parent_id);
        });
      });
      setItemsToAdd(function (itemsToAdd) {
        return itemsToAdd.filter(function (item) {
          return !itemIdsToRemove.includes(item.id);
        });
      });
      setItemsToRemove(function (oldItemsToRemove) {
        return _toConsumableArray(new Set([].concat(_toConsumableArray(oldItemsToRemove), _toConsumableArray(_itemsToRemove))));
      });
    }
  }, [selectedItems, topics]);
  var onSubmit = function onSubmit() {
    onChangeSelectedTopics({
      selectedItems: selectedItems,
      indeterminateItems: indeterminateItems,
      itemsToAdd: itemsToAdd,
      itemsToRemove: itemsToRemove
    });
    onClose();
  };
  var search = function search(searchValue, topics) {
    /**
     * Desired search behaviour:
     *
     * - If the search term matches the name of a top-level topic,
     * all subtopics should be shown
     *
     * - If the search term matches the name of one or more subtopics,
     * but NOT their parent topic, the parent and only the matching
     * subtopics should be shown (without any not-matching siblings).
     */
    var matches = [];
    var parentTopics = topics === null || topics === void 0 ? void 0 : topics.filter(function (topic) {
      return topic.parent_id === null;
    });
    parentTopics.forEach(function (parent) {
      var isMatch = isSearchMatch(parent.name, searchValue);
      var children = topics === null || topics === void 0 ? void 0 : topics.filter(function (el) {
        return el.parent_id === parent.id;
      });
      var matchingChildren = children.filter(function (child) {
        return isSearchMatch(child.name, searchValue);
      });
      var hasMatchingChildren = matchingChildren.length > 0;
      if (isMatch || hasMatchingChildren) {
        var childrenToAdd = isMatch ? children : matchingChildren;
        matches.push.apply(matches, [parent].concat(_toConsumableArray(childrenToAdd)));
      }
    });
    return Array.from(new Set(matches));
  };
  var selectedAndIndeterminateItems = topics === null || topics === void 0 ? void 0 : topics.filter(function (item) {
    return selectedItemIds.includes(item.id) || indeterminateItemIds.includes(item.id);
  });
  var items = search(searchValue, topics);
  var labels = {
    getSelectionStatus: function getSelectionStatus(count) {
      return t('topic_selection_status', {
        count: count
      });
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    "aria-label": title,
    id: "topic-selector-modal",
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ItemPickerUI, {
    view: view,
    onChangeView: changeView,
    selectedItemCount: selectedAndIndeterminateItems.length,
    labels: labels,
    searchValue: searchValue,
    onSubmit: onSubmit,
    onClose: onClose,
    onSearchValueChange: setSearchValue
  }, /*#__PURE__*/React.createElement(TopicSelectorBody, {
    view: view,
    items: items,
    selectedItems: selectedItems,
    indeterminateItems: indeterminateItems,
    selectedAndIndeterminateItems: selectedAndIndeterminateItems,
    onChange: onChange,
    isLoading: isLoading
  }))));
}
export default TopicSelector;